import { Component } from '@angular/core';
import { Platform, NavController } from 'ionic-angular';
import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';

@Component({
  selector: 'page-savoir-plus',
  templateUrl: 'savoir-plus.html'
})
export class SavoirPlusComponent {
    constructor(
        private platform: Platform,
        private navCtrl: NavController,
        private ga: GoogleAnalytics
    ) {
        this.platform.ready().then(_ => {
            this.ga.trackView("En savoir plus");
        }); 
    }

    goBack(): any {
        this.navCtrl.pop();
    }
}



// WEBPACK FOOTER //
// ./src/pages/savoir-plus/savoir-plus.ts